<div class="d-flex justify-content-between align-items-center w-100">
	<form class="mb-0">
		<div class="input-group">
			<button class="btn btn-primary te-outline-primary force-b-radius" [class.show]="d.isOpen()" (click)="d.toggle()" type="button" id="button-date-range">
				<fa-icon [icon]="faCalendarDays" class="me-2"></fa-icon>
				{{ formatRange(fromDate, toDate) }}
				<fa-icon [icon]="faCaretDown" class="ms-2"></fa-icon>
			</button>
			<input ngbDatepicker #d="ngbDatepicker" [displayMonths]="2" [autoClose]="'outside'" [startDate]="fromDate" [dayTemplate]="t"
				[minDate]="startDate()" [maxDate]="calendar.getToday()" outsideDays="hidden" tabindex="-1" style="position: absolute; opacity: 0; pointer-events: none;"
				(dateSelect)="onDateSelection($event)" [footerTemplate]="footerTemplate" (closed)="onConfirm()" [autoClose]="false" />
		</div>
		<ng-template #t let-date let-focused="focused">
			<span class="custom-day"
				ngbTooltip="{{ getTooltipForDate(date) }}"
				[class.start-date]="isStartDate(date)"
				[class.focused]="focused"
				[class.range]="isRange(date)"
				[class.faded]="isHovered(date) || isInside(date)"
				[class.range-start]="fromDate && date.equals(fromDate)"
				[class.range-end]="toDate && date.equals(toDate)"
				(mouseenter)="hoveredDate = date"
				(mouseleave)="hoveredDate = null">
				{{ date.day }}
			</span>
		</ng-template>
	</form>
	<button class="btn btn-primary ms-3" (click)="resetDates()" i18n>Mese corrente di fatturazione</button>
</div>

<ng-template #footerTemplate>
	<div class="d-flex justify-content-center">
		<button class="btn btn-primary mb-2" (click)="d.close()">Conferma</button>
	</div>
</ng-template>
